//extracting cookie with keyname=x-crm-access-token
import { jwtDecode } from 'jwt-decode';
export const cookieToken = ('; ' + document.cookie)
  .split(`; x-crm-access-token=`)
  .pop()
  .split(';')[0];

export const hasCookieToken = Boolean(cookieToken);

export const parseJwt = function (token) {
  let decodedToken = {};
  try {
    decodedToken = jwtDecode(token);
  } catch (err) {
    console.log('Invalid token ');
  }
  return decodedToken;
};

export const getCurrentUserEmail = () => {
  return parseJwt(cookieToken)?.email_id || null;
};

export const getCurrentUserId = () => {
  const decoded = parseJwt(cookieToken);
  return decoded?.external_user_id || decoded?.id || null;
};

export const isLifelineMode =
  window.location.pathname.includes('lifeline') &&
  !window.location.pathname.includes('smartplugs');

export const isSmartPlugMode = window.location.pathname.includes('smartplugs');

export const isAdminDashboard =
  window.location.pathname.includes('admin-dashboard');

export const isPlayGroundMode =
  JSON.parse(sessionStorage.getItem('playGroundMode')) && isLifelineMode;
